// Module
var code = "<div class=\"full-width-dashed-button add-button-dashed add-button-dashed-{{vm.size || 'xs'}}\" ng-click=\"vm.onClick()\"> <div> <p class=\"text-medium no-margin\"> <i class=\"fa fa-plus\"></i> {{ vm.label }} </p> </div> </div> ";
// Exports
module.exports = code;